const EVENT_PAYLOAD_SIZE_BYTES_LIMIT = 32 * 1024; // 32 KB

const RETRY_REASON_CLIENT_NETWORK = 'client-network';
const RETRY_REASON_CLIENT_TIMEOUT = 'client-timeout';
const DEFAULT_RETRY_REASON = RETRY_REASON_CLIENT_NETWORK;

const INTEGRATIONS_ERROR_CATEGORY = 'integrations';

export {
  EVENT_PAYLOAD_SIZE_BYTES_LIMIT,
  RETRY_REASON_CLIENT_NETWORK,
  RETRY_REASON_CLIENT_TIMEOUT,
  DEFAULT_RETRY_REASON,
  INTEGRATIONS_ERROR_CATEGORY,
};
